import { Component, Input } from '@angular/core';

/**
   * Logger Factory
   * @namespace color: name of color
   * @namespace outline: If true, activates a transparent button style with a border.
   * @namespace block: If true, activates a button style that fills the available width.
   * @namespace disabled: If true, thr button is disable
   * @namespace small: If true, the width and height is auto
   * @namespace type: is the type of button type="button|submit"
*/

@Component({
  selector: 'ute-button',
  templateUrl: 'ute-button.component.html'
})
export class UteButtonComponent {
  @Input() color: string;
  @Input() type: string;
  @Input() outline: boolean = false;
  @Input() block: boolean = false;
  @Input() disabled: boolean = false;
  @Input() small: boolean = false;
  constructor() {}
}


// WEBPACK FOOTER //
// ./src/app/components/atoms/ute-button/ute-buttons.component.ts